import { z } from 'zod';
import { PinComponentSchema } from '../pin-component';
import { LayoutPartSchema } from '../pin-component/layout-part';
import { BaseInteractiveQuestionPinSettingsSchema, BasePinSchema, BaseTemplateLayoutSchema } from './base-pin';

export const AnswerByCategoryPinLayoutKeySettingsSchema = z.enum(['TITLE_ONLY']);
export type AnswerByCategoryPinLayoutKey = z.infer<typeof AnswerByCategoryPinLayoutKeySettingsSchema>;

export const AnswerByCategoryPinLayoutPartKeySchema = LayoutPartSchema.extract(['TITLE']);

export const AnswerByCategoryPinLayoutTemplateSchema = BaseTemplateLayoutSchema.extend(
  z.object({
    key: AnswerByCategoryPinLayoutKeySettingsSchema,
    layoutParts: z.partialRecord(AnswerByCategoryPinLayoutPartKeySchema, PinComponentSchema.optional()),
  }).shape
);
export type AnswerByCategoryPinLayoutTemplate = z.infer<typeof AnswerByCategoryPinLayoutTemplateSchema>;

export const AnswerByCategoryPinSettingsSchema = BaseInteractiveQuestionPinSettingsSchema.extend(
  z.object({
    questionId: z.string().optional(),
    layout: AnswerByCategoryPinLayoutKeySettingsSchema,
    layoutParts: z.partialRecord(AnswerByCategoryPinLayoutPartKeySchema, z.string().optional()),
  }).shape
);
export type AnswerByCategoryPinSettings = z.infer<typeof AnswerByCategoryPinSettingsSchema>;

export const AnswerByCategoryPinTypeSchema = z.literal('ANSWER_BY_CATEGORY');

export const AnswerByCategoryPinSchema = BasePinSchema.extend(
  z.object({
    type: AnswerByCategoryPinTypeSchema,
    settings: AnswerByCategoryPinSettingsSchema,
  }).shape
);
export type AnswerByCategoryPin = z.infer<typeof AnswerByCategoryPinSchema>;
